import React from "react";
import { ChevronDown } from "lucide-react";

/**
 * Questions and answers that open and close, built on <details>: the answers are always in the page (so search
 * engines and AI assistants read them) and it works without JavaScript.
 */
export default function FaqList({ items, testId = "faq-list" }) {
    const list = (items || []).filter((f) => f && f.question && f.answer);
    if (!list.length) return null;
    return (
        <div className="space-y-3" data-testid={testId}>
            {list.map((f, i) => (
                <details key={f.id || i} className="faq-item group border border-slate-200 rounded-2xl px-5 bg-white" data-testid={f.id ? `faq-${f.id}` : undefined}>
                    <summary className="flex items-center justify-between gap-4 py-5 cursor-pointer list-none font-serif-display text-xl text-[var(--navy)]">
                        <span>{f.question}</span>
                        <ChevronDown size={18} className="shrink-0 text-slate-500 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" />
                    </summary>
                    <div className="text-slate-600 leading-relaxed pb-5 whitespace-pre-line">{f.answer}</div>
                </details>
            ))}
        </div>
    );
}
